module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/c586e885d7b16a4d296c1926002294a6.png";